angular.module('AccountingBoxApp')
    .config(function($stateProvider) {
        $stateProvider
            .state('app.company.inbox', {
                url: '/inbox',
                templateUrl: 'app/inbox/inbox.html',
                controller: 'InboxCtrl',
                controllerAs: 'iu',
            })
            //
            // .state('app.company.inbox.processed', {
            //     url: '/processed',
            //     templateUrl: 'app/inbox/processed/processed.html',
            //     controller: 'InboxProcessedCtrl',
            //     controllerAs: 'ip',
            //     resolve: {
            //         Attachment: 'Attachment',
            //         processed: function(Attachment) {
            //             return Attachment.query({
            //                 filter: {
            //                     where: {
            //                         transactionId: {
            //                             neq: ''
            //                         }
            //                     },
            //                     include: ['transaction']
            //                 }
            //             });
            //         }
            //     }
            // });
    });
